const IMAGE_EXTS = new Set(['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.ico', '.tiff', '.tif', '.avif']);
const VIDEO_EXTS = new Set(['.mp4', '.webm', '.ogg', '.mov', '.avi', '.wmv', '.flv', '.mkv', '.m4v', '.3gp']);
const AUDIO_EXTS = new Set(['.mp3', '.wav', '.ogg', '.flac', '.aac', '.wma', '.m4a', '.opus', '.aif', '.aiff']);

const getFileExt = (fileName) => {
  const path = (fileName || '').split('?')[0].split('#')[0];
  const idx = path.lastIndexOf('.');
  return idx === -1 ? '' : path.slice(idx).toLowerCase();
}

export const isImage = (fileName) => IMAGE_EXTS.has(getFileExt(fileName));
export const isVideo = (fileName) => VIDEO_EXTS.has(getFileExt(fileName));
export const isAudio = (fileName) => AUDIO_EXTS.has(getFileExt(fileName));

const DOC_EXTS = new Set(['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt']);
const PDF_EXTS = new Set(['.pdf']);

export const isDocument = (fileName) => DOC_EXTS.has(getFileExt(fileName));
export const isPdf = (fileName) => PDF_EXTS.has(getFileExt(fileName));
export const isWord = (fileName) => ['.doc', '.docx'].includes(getFileExt(fileName));

/**
 * 统一文件分类
 * @param {string} fileName
 * @returns {'video'|'audio'|'image'|'pdf'|'word'|'document'|'unknown'}
 */
export const getFileCategory = (fileName) => {
  if (isVideo(fileName)) return 'video';
  if (isAudio(fileName)) return 'audio';
  if (isImage(fileName)) return 'image';
  if (isPdf(fileName)) return 'pdf';
  if (isWord(fileName)) return 'word';
  if (isDocument(fileName)) return 'document';
  return 'unknown';
}
